// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"BookPrice__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/BookPrice/BookPrice.scss
 ** module id = 891
 ** module chunks = 1
 **/